(function (window) {
  /**
   * Generates the `origin` GET parameter for Google Maps directions URL. If
   * the address box has an address that will be used for the origin. If the
   * distance setting is on itll use that. If on an iPhone or Android and on
   * an english based device itll use "Current Location" as the origin.
   * Otherwise, itll fall back to Lat Lng or an empty string.
   *
   * @returns {string}
   */
  var buildTargetAddress = function () {
    const markerMeasure = BatchGeoStore.getState().MarkerMeasure;
    if (markerMeasure.enabled && markerMeasure.position) {
      return `&origin=${markerMeasure.position.lat()},${markerMeasure.position.lng()}`;
    }

    var markersData = window.batchGeoGoogleMapsManager.settings.markersData;
    var userLocation = BatchGeoStore.getState().UserLocation;

    // Firstly, if there's a zip/address(ish) value in the address/search box, use that as your start.
    // TODO: Turn this into a UI component
    var addressBoxVal =
      $("#addressBox").val() || $(".storeLocator-search-input").val() || "";
    //remove strings inside of parentheses since that will just be the column name
    addressBoxVal = addressBoxVal.replace(/ *\([^)]*\) */g, "");

    // Our regex is not meant to check for sure if its an address, just a sanity check. The first test is looking for a
    // number space letter, like `12 apple` would get through but `apple computer` would not. The second test is for zip codes
    if (
      (addressBoxVal !== "" &&
        (/\d+\s\w+/.test(addressBoxVal) ||
          /^\d{5}(?:[-\s]\d{4})?$/.test(addressBoxVal))) ||
      /^[a-zA-Z\s]+$/.test(addressBoxVal) //need to support regular text
    ) {
      return "&origin=" + addressBoxVal;
    }

    // Next if user location is stored in state, we will use their coordinates as the start.
    if (userLocation && userLocation.active) {
      return "&origin=" + userLocation.latitude + "," + userLocation.longitude;
    }

    // Next, if distance is enabled we add anchor marker as the start address
    if (markersData.dist_cb_status) {
      var isCurrentLocation =
        BatchGeoDevices.is("mobile") && window.language === "en";
      var targetMarker = markersData.mapRS[0];
      // If it's mobile and english we can use Current location, otherwise use the marker coordinates
      return (
        "&origin=" +
        (isCurrentLocation
          ? "Current Location"
          : targetMarker.lt + "," + targetMarker.ln)
      );
    }

    // all else fails
    return "";
  };

  /**
   *
   * Uses regex to try and identify a sub premise component
   * in the provided address.
   *
   * @Note
   * Regex is not exhaustive. Geocoder is only entity able to accurately identify subpremise. Only use when `<rM|options>.dirAddr` is undefined.
   *
   * @param {string} address
   * @returns {boolean}
   */
  const addressContainsSubPremise = (address) => {
    const rex = /(^|[ |,])((s(ui)?te|apt|unit|#)((\s*[#a-zA-Z0-9]+\s*)),?)/gim;
    return address.match(rex)?.length;
  };

  /**
   * Returns a Google Maps directions URL. If it can it will also try to add
   * an "origin" point. For example, if you have geolocation on itll use the
   * current location as the origin.
   *
   * @param {object} address The address or coordinates to set the Google Maps
   * directions URL to
   *
   * @returns {string} A Google Maps directions URL
   */
  var BatchGeoInfoWindowGenerateDirections = function (address, options = {}) {
    const targetAddress = buildTargetAddress();
    // If geocoder identified address as a subpremise
    // the options should contain an alternative address.
    // Use the alternative address if it exists, otherwise use user provided address
    const directionsAddress = options.dirAddr || address;
    const urlCoords = encodeURIComponent(
      BatchGeo.stripHTML(directionsAddress, " "),
    );

    if (
      // no target address (geolocation off)
      !targetAddress.length ||
      // could be map made before subpremise change, use regex check
      (options.dirAddr === undefined && addressContainsSubPremise(address))
    ) {
      // disabled geolocation or identified as existing map with sub premise address
      return "https://www.google.com/maps/search/?api=1&query=" + urlCoords;
    } else {
      return (
        "https://www.google.com/maps/dir/?api=1&destination=" +
        urlCoords +
        targetAddress
      );
    }
  };

  window.BatchGeoInfoWindowGenerateDirections =
    BatchGeoInfoWindowGenerateDirections;
})(window);
